import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({data, tableColumns}) => {

    const columns = [
        {id: "user_name", label: "Agente", className: "w-[25%]", renderCell: item => item.user_name ?? ""},
        {id: "date_time", label: "Data/hora", className: "w-[25%]", renderCell: item => item.date_time ?? ""},
        {id: "action", label: "Ação", className: "w-[25%]", renderCell: item => item.action ?? ""},
        {id: "application", label: "Aplicação", className: "w-[25%]", renderCell: item => item.application ?? ""},
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Auditoria`, "audit");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 ? (
                <div className="alert alert-info p-2 h6 text-center mt-[16px]!">Todas as colunas foram ocultadas.</div>
            ) : (
                <table id="audit" className="table report-table mt-[25px]" sheet-name="Auditoria">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map(column => (
                                <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.map((item, index) => (
                            <tr key={index} className="table-break-word">
                                {visibleColumns.map(column => (
                                    <td key={column.id} className={column.className}>{column.renderCell(item)}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;